import type { CmsData } from '@packages/cms-components/interfaces/webapp_json';
import { useDeviceType } from '@packages/shared';
import Box from '@mui/material/Box';
import Accordion from './FooterAccordion';
import BlockContent from './BlockContent';
import AreaTop from './AreaTop';
import AreaSocket from './AreaSocket';

type PageRendererProps = {
  data: CmsData;
  socketOnly?: boolean;
};

export enum PageRendererTestIds {
  main = 'page-renderer',
  mainMob = 'page-renderer-mob',
}

const PageRenderer = ({ data, socketOnly = false }: PageRendererProps): JSX.Element => {
  const { isMobile } = useDeviceType();

  return (
    <>
      {!socketOnly && <AreaTop data={data} />}
      <Box
        sx={({ spacing }) => ({
          backgroundColor: 'grey.light',
          ...(isMobile
            ? {
                m: spacing(socketOnly ? 11.5 : 6.5, 'auto', 0, 'auto'),
                p: 0,
                typography: 'body1',
              }
            : {
                typography: 'caption',
                p: {
                  margin: 0,
                  '+ p': {
                    pt: 1,
                  },
                },
                '& .footer_block_badges': {
                  display: 'flex',
                  gap: 1.5,
                },
              }),
        })}
        data-testid={isMobile ? PageRendererTestIds.mainMob : PageRendererTestIds.main}
      >
        {!socketOnly && (isMobile ? <Accordion data={data} /> : <BlockContent data={data} />)}
        <AreaSocket data={data} />
      </Box>
    </>
  );
};

// eslint-disable-next-line import/no-default-export
export default PageRenderer;
